import CACA1070RequestModel from '@/api/data/CAC/CACA1070/CACA1070RequestModel'
import CACA1070ResponseModel from '@/api/data/CAC/CACA1070/CACA1070ResponseModel'

import ApiUrlConstants from '@/common/ApiUrlConstants'
import RestService from '@/common/RestService'
import CommonConstants from '@/common/CommonConstants'

export default class CACG1070Service {
  /**
   * CACA1070RequestModelを初期化する。
   */
  private caca1070RequestModel = new CACA1070RequestModel()

  /**
   * 「caca1070RequestModel」APIのリクエストを初期化する。
   * @param productNo 商品番号
   * @param shhnCd 当社商品コード
   * @returns caca1070ResponseModel
   */
  public async callAPICACA1070(productNo, shhnCd) {
    this.caca1070RequestModel.productNo = productNo
    this.caca1070RequestModel.shhnCd = shhnCd
    const caca1070ResponseModel: CACA1070ResponseModel = <
      CACA1070ResponseModel
    > await RestService.post(ApiUrlConstants.CACA1070, this.caca1070RequestModel)
    return caca1070ResponseModel
  }

  /**
   * 運用報告書の表示位置設定
   *
   * @param operationReport
   * @returns operatProductInvestmentRpPdfInfoLst
   */
  public setPlaceOperationReport(operatProductInvestmentRpPdfInfoLst) {
    // 返却されたデータを含む配列を作成する。
    const dataReturn = []

    // operatProductInvestmentRpPdfInfoLst配列をitem要素でループする。
    for (let i = 0; i < operatProductInvestmentRpPdfInfoLst.length; i++) {
      // 決算年月日が2014年12月以降（settlementDate < 20141201）の場合
      if (
        operatProductInvestmentRpPdfInfoLst[i].settlementDate <
        CommonConstants.OPERATION_REPORT_CLOSING_DATE
      ) {
        dataReturn.push(operatProductInvestmentRpPdfInfoLst[i])
        continue
      }

      // 決算年月日が2014年12月以降（settlementDate >= 20141201）の場合
      // 運用報告書（交付）（docTypeId === "9"）の場合
      if (operatProductInvestmentRpPdfInfoLst[i].docTypeId === '9') {
        dataReturn.push(operatProductInvestmentRpPdfInfoLst[i])

        // 次の要素が同一決算期の運用報告書（全体版）であるかどうかチェックする。
        if (
          i < operatProductInvestmentRpPdfInfoLst.length - 1 &&
          operatProductInvestmentRpPdfInfoLst[i].settlementDate ===
            operatProductInvestmentRpPdfInfoLst[i + 1].settlementDate &&
          operatProductInvestmentRpPdfInfoLst[i].settlementTerm ===
            operatProductInvestmentRpPdfInfoLst[i + 1].settlementTerm &&
          operatProductInvestmentRpPdfInfoLst[i + 1].docTypeId === '10'
        ) {
          dataReturn.push(operatProductInvestmentRpPdfInfoLst[i + 1])
          i++
        } else {
          dataReturn.push({})
        }
        continue
      }

      // 運用報告書（全体版）（docTypeId === "10"）の場合
      dataReturn.push({})
      dataReturn.push(operatProductInvestmentRpPdfInfoLst[i])
    }
    return dataReturn
  }
}
